<template>
    <div>
        <JoinerModal></JoinerModal>
        <admin-member-modal/>
      총 {{0}} 명
        <table class="table text-center vertical-grabber">
            <thead>
                <tr>
                    <th v-for="key, i in columns"
                        @click="sortBy(key)"
                        :class="{ active: sortKey === key , 'pc-only':['description','createdDate','isAttendance'].includes(key)}" >
                        {{ key | makeKor }}
                        {{ i===0 ? '('+filteredHeroes.length+')': ''}}
                        <span v-if="['memberName','status','description','createdDate','isAttendance'].includes(key)" class="arrow" :class="sortOrders[key] > 0 ? 'asc' : 'dsc'"></span>
                    </th>
<!--                    <th v-if="activity.isRepeatableDayOfWeek">-->
<!--                        참여요일-->
<!--                    </th>-->
                    <th>
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="article in filteredHeroes">
                    <td v-for="key in columns" :class="{'pc-only':['description','createdDate'].includes(key)}" class="align-middle"  style="padding: 3px">
                        <div v-if="key === 'memberName'">
                            <button class="btn btn-outline-primary btn-sm" @click="memberModal(article.memberId)">{{article.memberName}}</button>
                        </div>
                        <div v-else-if="key === 'status'">
                            <select v-model="article.status" class="form-control" @change="setActivityMember(article)">
                                <option v-if="['PAID', 'WAITING'].includes(v) ? $parent.activity.activityJoinCost > 0 : true" :disabled="article.status === v" v-bind:value="v" v-for="(k,v) in statusMap">
                                    {{k}}
                                </option>
                            </select>
                        </div>
                        <div v-else-if="key === 'description'">
                            <div class="input-group">
                                <textarea v-model="article.description" class="form-control" readonly="readonly"  aria-describedby="button-addon3"></textarea>
                                <!--<div class="input-group-addon">
                                    <button class="btn btn-outline-danger" data-toggle="collapse" id="button-addon3" @click="setActivityMember(article)">확인</button>
                                </div>-->
                            </div>
                        </div>
                        <div v-else-if="key === 'createdDate'">
                            {{$root.$children[0].dateFormat(article.createdDate,'YYYY.MM.DD HH:mm')}}
                        </div>
                        <div v-else-if="key === 'isAttendance'">
                            <div class="d-block">
                                <Toggle v-model="article.isAttendance" @input="setJoinedMember(article)" />
                            </div>
                            <!--
                            <input type="checkbox" v-model="article.isAttendance"  @change="setJoinedMember(article)" :disabled="!['PAID', 'APPROVED','COMPLETED'].includes(article.status)" >
                            -->
                            <div class="d-inline">
                                <label v-if="!['PAID', 'APPROVED','COMPLETED'].includes(article.status)" class=" text-danger" >
                                    {{article.status === 'WAITING' ? '미결제' : '미승인'}}
                                </label>
                                <label v-else-if="['PAID', 'APPROVED'].includes(article.status)" class=" text-primary" >
                                    {{article.isAttendance ? '출석함' : '출석체크'}}
                                </label>
                                <label v-else-if="article.status = 'COMPLETED'" class=" text-success" >
                                    참여함
                                </label>
                            </div>

                        </div>


                    </td>
<!--                    <td v-if="activity.isRepeatableDayOfWeek">-->
<!--                            {{article.isRepeatableMon ? '월' : ''}}-->
<!--                            {{article.isRepeatableTue ? '화' : ''}}-->
<!--                            {{article.isRepeatableWed ? '수' : ''}}-->
<!--                            {{article.isRepeatableThu ? '목' : ''}}-->
<!--                            {{article.isRepeatableFri ? '금' : ''}}-->
<!--                            {{article.isRepeatableSat ? '토' : ''}}-->
<!--                            {{article.isRepeatableSun ? '일' : ''}}-->
<!--                    </td>-->
                    <td>
                        <button type="button" class="btn btn-outline-primary" @click="joinerModal(article)">자세히</button>


                    </td>
                </tr>
            </tbody>
        </table>
    </div>

</template>

<script>
    import AdminMemberModal from '@/components/admin/AdminMemberModal.vue'
    import JoinerModal from '@/components/admin/JoinerModal.vue'
    import Toggle from '@/components/admin/Toggle.vue'

    export default {
        name: 'adminGrid',
        props: {
            activity: Object,
            heroes: Array,
            columns: Array,
            filterKey: String
        },
        components: {Toggle, AdminMemberModal, JoinerModal},
        data: function () {
            let sortOrders = {}
            this.columns.forEach(function (key) {
                sortOrders[key] = 1
            })
            return {
                sortKey: '',
                sortOrders: sortOrders,
                statusMap: {},
            }
        },
        computed: {
            filteredHeroes: function () {
                let sortKey = this.sortKey
                let filterKey = this.filterKey && this.filterKey.toLowerCase()
                let order = this.sortOrders[sortKey] || 1
                let heroes = this.heroes
                if (filterKey) {
                    heroes = heroes.filter(function (row) {
                        return Object.keys(row).some(function (key) {
                            return String(row[key]).toLowerCase().indexOf(filterKey) > -1
                        })
                    })
                }
                if (sortKey) {
                    heroes = heroes.slice().sort(function (a, b) {
                        a = a[sortKey]
                        b = b[sortKey]
                        return (a === b ? 0 : a > b ? 1 : -1) * order
                    })
                }
                return heroes
            }
        },
        filters: {
            capitalize: function (str) {
                return str.charAt(0).toUpperCase() + str.slice(1)
            },
            makeKor: function (str) {
                let joinerMap = {
                    status: "상태",
                    description: "메모",
                    isAttendance: "출석체크",
                    createdDate:"신청일",
                    memberName: "신청자",
                }
                return joinerMap[str];
            }
        },
        methods: {
            sortBy: function (key) {
                this.sortKey = key
                this.sortOrders[key] = this.sortOrders[key] * -1
            },
            getStatusMap() {
                let me = this;
                let url = process.env.VUE_APP_ADMIN_API_URL + `/activity/member/status`;
                //console.log(u);
                this.axios.get(url)
                    .then(function (res) {
                        me.statusMap = res.data;
                    }).catch(function (error) {
                    console.log(error);
                });
            },

            setActivityMember: function(obj) {
                let me = this;
                this.axios.put(process.env.VUE_APP_ADMIN_API_URL + `/activity/member/manage`, obj)
                    .then(function () {
                        me.$root.$children[0].commonDialog('활동멤버관리','수정 되었습니다.');
                        me.$parent.getList();
                    }).catch(function (error) {
                    console.log(error);
                    alert('등록 에러');
                });
            },
            setJoinedMember(article) {
                if(!['PAID', 'APPROVED','COMPLETED'].includes(article.status)) {
                    article.isAttendance = !article.isAttendance;
                    return;
                }
                let msg = `출석 체크 ${article.isAttendance ? '' : '취소'} 하시겠습니까?`;
                if(article.isAttendance) {
                    if(['PAID', 'APPROVED'].includes(article.status)) {
                        msg += '\n출석 여부만 변경되며, 봉사시간은 참여완료 상태 변경시 부여됩니다.';
                    }
                } else {
                    if(['COMPLETED'].includes(article.status)) {
                        msg += '\n봉사시간이 차감되며 불참상태로 변경합니다.';
                    }
                }

                if(confirm(msg)) {
                    /* 출첵했다고 참여 완료로 바꾸지 않음
                    if(article.isAttendance && ['PAID', 'APPROVED'].includes(article.status)) {
                        article.status = "COMPLETED";
                    }*/

                    if(!article.isAttendance && ['COMPLETED'].includes(article.status)) {
                        article.status = "NOSHOW";
                    }
                    //let me = this;
                    this.setActivityMember(article);
                    /*
                    this.axios.put(process.env.VUE_APP_ADMIN_API_URL + `/activity/member/manage/joined`, article)
                        .then(function (res) {
                            //me.$parent.commonDialog('활동멤버관리','수정 되었습니다.');
                            me.$parent.getList();
                        }).catch(function (error) {
                        console.log(error);
                        alert('등록 에러');
                    });*/
                } else {
                    //this.$parent.getList();
                    article.isAttendance = !article.isAttendance;
                    //return;
                }
            },
            memberModal(id){
                let me = this;
                this.axios.get(process.env.VUE_APP_MEMBER_API_URL + `/${id}`)
                    .then(function (res) {
                        me.$modal.show('AdminMemberModal', {'member':res.data})
                    }).catch(function (error) {
                    //console.log(error);
                    alert(error);
                });
            },
            joinerModal(article){
                this.$modal.show('JoinerModal', {'article':article})
            },
        },
        mounted() {
            this.getStatusMap();
        }
    }
</script>
<style>

    th.active .arrow {
        opacity: 1;
    }

    .arrow {
        display: inline-block;
        vertical-align: middle;
        width: 0;
        height: 0;
        margin-left: 5px;
        opacity: 0.66;
    }

    .arrow.asc {
        border-left: 4px solid transparent;
        border-right: 4px solid transparent;
        border-bottom: 4px solid black;
    }

    .arrow.dsc {
        border-left: 4px solid transparent;
        border-right: 4px solid transparent;
        border-top: 4px solid black;
    }
</style>